import { render } from "./Broadcast.vue?vue&type=template&id=90a1506a&scoped=true"
import script from "./Broadcast.vue?vue&type=script&lang=js"
export * from "./Broadcast.vue?vue&type=script&lang=js"

import "./Broadcast.vue?vue&type=style&index=0&id=90a1506a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-90a1506a"

export default script